<section class="fwc-container fwc-footer-main">
  <div class="fwc-row">
    <div class="fwc-col-9 md-12 fwc-reverse-column-mobile">
      <div class="fwc-footer-links">
        <p class="footer-link">Developed With Anthem</p>
      </div>
      <div class="fwc-footer-links">
        @if (footer && footer.legal != null) {
          <a href="{{footer.legal}}" class="footer-link" rel="noreferrer noopener" target="_blank">Terms of Use</a>
        }
        @if (footer && footer.privacy != null) {
          <a href="{{footer.privacy}}" class="footer-link" rel="noreferrer noopener" target="_blank">Protecting Your Privacy</a>
        }
        @if (footer && footer.contactInfo && (footer.contactInfo.email || footer.contactInfo.phone)) {
          <a href="javascript:void(0)" class="footer-link" (click)="openModal()">Contact Us</a>
        }
      </div>

    </div>
    <div class="fwc-col-3 md-12">
      <div class="fwc-footer-flex-column">
        <a class="fwc-btn fwc-btn-ghost" aria-label="WCAG" href="https://www.w3.org/WAI/standards-guidelines/wcag/" rel="noreferrer noopener" target="_blank" data-analytics-context="Footer" data-analytics-name="WCAG 2.1 AA" title="WCAG Standard Guidelines"><span class="fwc-icon fwc-icon-double-tick"></span>WCAG 2.1 AA</a>
      </div>
    </div>
  </div>
  <div class="fwc-row">
    <div class="fwc-col-12 md-12 fwc-reverse-column-mobile top-xs" [innerHTML]="brandTagline | safeHtml"></div>
  </div>
</section>

<fwc-modal id="contactModal" text-header="Contact Us">
  @if (footer && footer.contactInfo && (footer.contactInfo.email || footer.contactInfo.phone)) {
    <div slot="body">
      <h4 class="btm-sm">Have a question? We're here to help.</h4>
      <div class="fwc-container">
        <div class="fwc-row">
          <div class="fwc-col-12 fwc-card-generic flat card-container">
            @if (footer && footer.contactInfo && footer.contactInfo.phone) {
              <div class="fwc-row fwc-row-bm a-center">
                <span class="fwc-icon fwc-icon-phone right-xs"></span>
                <h6 class="right-xxs">Call: </h6>
                <h6> {{footer.contactInfo.phone}}</h6>
              </div>
            }
            @if (footer && footer.contactInfo && footer.contactInfo.email) {
              <div class="fwc-row a-center">
                <span class="fwc-icon fwc-icon-email right-xs"></span>
                <h6 class="right-xxs">Email: </h6>
                <h6><a href="mailto:{{footer.contactInfo.email}}">{{footer.contactInfo.email}}</a></h6>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

  <div slot="actions">
    <button class="fwc-btn fwc-btn-primary" id="btnClose" (click)="closeModal()">Close</button>
  </div>
</fwc-modal>
